import { useUserSettingsStore } from '../user-settings/stores/user-settings.store';

export function useLocale() {
  const locale = useUserSettingsStore((s) => s.locale);

  if (!locale) {
    return navigator.languages[0];
  }

  return locale;
}
